export const INPUT_CHANGEVALUE = "Vendors_input_ChangeValue";

export const SELECT_CHANGEVALUE = "Vendors_State_Select_ChangeValue";
export const VENDORS = "vendors";
export const VENDORS_ADD = "vendor_add";
export const VENDORS_EDIT = "vender_edit";
export const VENDORS_DELETE = "vendor_deleted";

export const VENDORS_SETROWDATA = "vendors_set_rowdata";
export const MODEL_OPEN = "vendor_model_open";
export const MODEL_CLOSE = "vendor_model_close";

export const VENDORS_ADD_SUCCESSFUL = "vendor_add_successfull";
export const VENDORS_LIST_SUCCESSFUL = "vendor_list_successfull";
export const VENDORS_EDIT_SUCCESSFUL = "vendor_edit_successfull";

// export const VENDORS_ROW_SUCCESSFUL = 'vendor_row_successfull';
// export const GET_VENDOR_DETAILS = 'get_vendor_details';

export const UPLOAD_REQUEST = "upload_vendor_request";
export const UPLOAD_PRODUCTVENDORS_REQUEST = "upload_productvendor_request";
export const VENDOR_GST_VALIDATION = "vendor_gst_validation";

export const API_ERROR = "api_failed";
